import React, { useState } from "react";
import * as c from "./dropdownSectionBusinessTypes.module.scss";
import { graphql, Link, useStaticQuery } from "gatsby";
import { createItemSortOrder } from "@utils/helpers";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import DesktopNavbarDropdown from "@components/navbar/desktop/dropdowns/desktopNavbarDropdown";
import classNames from "classnames";
import defaultBg from "@images/nav/generic.jpg";

const navItemOrder = {
  "hair-salon-software": 0,
  "medical-spa-software": 1,
  "iv-therapy-software": 2,
  "skincare-studio-software": 3,
  "beauty-studio-software": 4,
  "massage-studio-software": 5,
  "hair-removal-studio-software": 6,
  "tattoo-piercing-studio-software": 7,
  "nail-salon-software": 8,
  "barbershop-software": 9,
  "wellness-center-software": 10,
  "spa-software": 11,
};

const Column = ({ className, children, onMouseLeave }) => (
  <div className={className} onMouseLeave={onMouseLeave}>
    {children}
  </div>
);

const getDesktopSortOrder = createItemSortOrder(navItemOrder);

export default function DropdownSectionBusinessTypes() {
  const data = useStaticQuery(
    graphql`
      query {
        allContentfulNavbar(filter: {}) {
          nodes {
            allSolutions {
              slug
              title: navbarOverviewTitle
              contentful_id
              navbarImage {
                gatsbyImageData(layout: CONSTRAINED, width: 360, height: 250)
              }
            }
          }
        }
      }
    `
  );

  const businessTypes = data.allContentfulNavbar.nodes[0].allSolutions;
  const sortedFeatures = [...businessTypes].sort((a, b) => {
    const orderA = getDesktopSortOrder(a.slug);
    const orderB = getDesktopSortOrder(b.slug);
    return orderA - orderB;
  });
  const [activeSlug, setActiveSlug] = useState(null);
  return (
    <>
      <DesktopNavbarDropdown label="Businesses">
        <Column
          className={c.features}
          onMouseLeave={() => {
            setActiveSlug(null);
          }}
        >
          <h2 className={c.label}>Solutions for…</h2>
          {sortedFeatures.map(({ slug, title }) => (
            <Link className={c.feature} to={`/solutions/${slug}/`} key={slug} onMouseOver={() => setActiveSlug(slug)}>
              <div className={c.text}>
                {/* TODO: This conditional is temp. & should be removed. Contentful should be updated instead */}
                <h4 className={c.title}>{title === "Hair Removal Studios" ? "Hair Removal" : title}</h4>
              </div>
            </Link>
          ))}
        </Column>
        <Column className={c.promo}>
          <div className={c.imgWrap}>
            {businessTypes.map(({ navbarImage, slug }) => (
              <GatsbyImage
                key={slug}
                alt={slug}
                className={classNames(c.image, slug === activeSlug && c.active)}
                image={getImage(navbarImage)}
              />
            ))}
            <img src={defaultBg} alt="Business owner smiling" className={c.defaultImg} />
          </div>
        </Column>
      </DesktopNavbarDropdown>
    </>
  );
}
